import './load-service-worker'
import './libs/jquery'
import './libs/lodash'
import * as kb from './kb'
import * as webpack from './webpack'
import {notifyWarning} from './notify'
import {captureSentryError} from './sentry'

// This file is part of the entry bundle included from webpack.config.js.
// It is included on "all" pages except the "login" page.
window.addEventListener('unhandledrejection', function(event) {
    if(event?.reason?.$isWarning) {
        // https://mpen.xyz/share/2022/05/phpstorm64_2022-05-09_20-40-50.png
        // Top: warning, bottom: uncaught
        console.warn("Uncaught promise:", event.reason)
        event.preventDefault()
    }
})

if(__DEV__) {
    // https://stackoverflow.com/a/37484622/65387
    // https://stackoverflow.com/a/45733566/65387
    // https://webpack.js.org/guides/hot-module-replacement/#enabling-hmr
    module.hot!.accept(err => {
        notifyWarning("Failed to accept hot update")
        console.warn(err)
    })
}

Object.assign(globalThis.kb ||= {} as typeof kb, kb)
Object.assign(globalThis, webpack)

$(() => {
    import(/* webpackPreload: true */ './pageload').catch(err => {
        captureSentryError(`Failed to import pageload.ts`, err, null, '89a5ced7-5fb7-4451-a046-2bba3be8c4b7')

        // if(typeof Sentry !== 'undefined') {
        //     const message = `Failed to import pageload.ts`
        //     Sentry.captureException(err, {
        //         level: Sentry.Severity.Error,
        //         fingerprint: ['89a5ced7-5fb7-4451-a046-2bba3be8c4b7'],
        //         extra: {
        //             message,
        //         }
        //     })
        //     // Once this error happens, "ReferenceError: runAsync is not defined" may also trigger -- because it's in this same bundle!
        //     // Sentry.addBreadcrumb({
        //     //     category: 'import',
        //     //     message: message,
        //     //     level: Sentry.Severity.Error,
        //     // })
        //     // Sentry.captureEvent({
        //     //     level: Sentry.Severity.Error,
        //     //     fingerprint: ['89a5ced7-5fb7-4451-a046-2bba3be8c4b7'],
        //     //     exception: { values: [err] },
        //     //     message: `Failed to import pageload.ts`,
        //     // });
        // }
    })
})

// import React from 'react'
// import {whyDidYouUpdate} from 'why-did-you-update'
//
// if (process.env.NODE_ENV !== 'production') {
//     // https://github.com/garbles/why-did-you-update#how-to
//     whyDidYouUpdate(React)
// }

// batchingForReactDom is no longer needed
// import 'mobx-react-lite/batchingForReactDom' // https://github.com/mobxjs/mobx-react-lite/#observer-batching

